import { useEffect, useRef, useState } from 'react';
import { IdentityResponse, PageResponse } from 'types';

const useList = () => {
  const page = useRef<number | undefined>(undefined);
  const totalElements = useRef<number>(0);
  const totalPages = useRef<number>(0);
  const content = useRef<any[] | undefined>(undefined);
  const [, setReload] = useState<number>(0);

  useEffect(() => {
    return () => reset();
  }, []);

  function updatePageable(val: PageResponse) {
    if (!val) {
      let prevItems = content.current ?? [];
      content.current = prevItems;
    } else {
      page.current = val.page;
      totalElements.current = val.totalElements;
      totalPages.current = val.totalPages;
      let prevItems = content.current ?? [];
      content.current = prevItems;
      if (val.content) {
        content.current = val.content;
      }
    }
    setReload((old) => old + 1);
  }

  function updateList(array: IdentityResponse[]) {
    page.current = 0;
    totalElements.current = array.length;
    totalPages.current = 1;
    let prevItems = content.current ?? [];
    content.current = prevItems;
    content.current = [...prevItems, ...array];
    setReload((old) => old + 1);
  }

  function reset() {
    page.current = 0;
    totalElements.current = 0;
    totalPages.current = 0;
    content.current = undefined;
    setReload((old) => old + 1);
  }

  function refresh() {
    page.current = -1;
    setReload((old) => old + 1);
  }

  function decrementPage() {
    if (page.current !== undefined) {
      page.current++;
    }
    setReload((old) => old + 1);
  }

  function incrementPage() {
    if (page.current !== undefined) {
      page.current++;
    }
    setReload((old) => old + 1);
  }

  function setPage(val: number) {
    if (page.current !== undefined) {
      page.current = val - 1;
    }
    setReload((old) => old + 1);
  }

  return {
    page: page.current,
    decrementPage: decrementPage,
    incrementPage: incrementPage,
    totalElements: totalElements.current,
    totalPages: totalPages.current,
    content: content.current,
    updatePageable: updatePageable,
    updateList: updateList,
    resetList: reset,
    refreshList: refresh,
    setPage: setPage,
  };
};

export default useList;
